import { useState } from "react";
import { loginUser, sendPasswordReset } from "../firebase/services";
import { useLanguage } from "../hooks/useLanguage";
import LangSwitcher from "../components/LangSwitcher";

export default function LoginPage() {
  const { t } = useLanguage();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showForgot, setShowForgot] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetMsg, setResetMsg] = useState("");
  const [resetLoading, setResetLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try { await loginUser(email, password); }
    catch (err) { setError(`[${err.code}] ${err.message}`); }
    finally { setLoading(false); }
  };

  const handleReset = async (e) => {
    e.preventDefault(); setResetMsg(""); setResetLoading(true);
    try {
      await sendPasswordReset(resetEmail);
      setResetMsg(t("auth.reset_success"));
    } catch (err) {
      if (err.code === "auth/user-not-found") setResetMsg("❌ Không tìm thấy tài khoản với email này.");
      else setResetMsg("❌ " + t("common.error") + ": " + err.message);
    } finally { setResetLoading(false); }
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-logo">PromoterHQ</div>
        <div className="login-sub">{t("auth.login_subtitle")}</div>

        {!showForgot ? (
          <>
            {error && <div className="alert alert-error">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">{t("auth.email")}</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="example@company.com" required />
              </div>
              <div className="form-group">
                <label className="form-label">{t("auth.password")}</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required />
              </div>
              <button className="btn btn-primary btn-full" type="submit" disabled={loading}>
                {loading ? t("auth.logging_in") : t("auth.login")}
              </button>
            </form>
            <div style={{ textAlign: "center", marginTop: 12 }}>
              <button className="btn-link" onClick={() => { setShowForgot(true); setResetEmail(email); setResetMsg(""); }}>
                {t("auth.forgot")}
              </button>
            </div>
          </>
        ) : (
          <>
            <div style={{ marginBottom: 12, fontWeight: 600 }}>{t("auth.reset_title")}</div>
            <div style={{ fontSize: 13, color: "#666", marginBottom: 16 }}>{t("auth.reset_desc")}</div>
            {resetMsg && <div className={`alert ${resetMsg.startsWith("✅") ? "alert-success" : "alert-error"}`}>{resetMsg}</div>}
            {!resetMsg.startsWith("✅") && (
              <form onSubmit={handleReset}>
                <div className="form-group">
                  <label className="form-label">{t("auth.email")}</label>
                  <input type="email" value={resetEmail} onChange={e => setResetEmail(e.target.value)} placeholder="example@company.com" required />
                </div>
                <button className="btn btn-primary btn-full" type="submit" disabled={resetLoading}>
                  {resetLoading ? t("auth.reset_sending") : t("auth.reset_send")}
                </button>
              </form>
            )}
            <div style={{ textAlign: "center", marginTop: 12 }}>
              <button className="btn-link" onClick={() => setShowForgot(false)}>{t("auth.back_to_login")}</button>
            </div>
          </>
        )}

        <div style={{ marginTop: 20, borderTop: "1px solid #f0f0f0", paddingTop: 14 }}>
          <LangSwitcher />
        </div>
      </div>
    </div>
  );
}
